// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.section-break {
   height: 2em;
}

a:hover {
   color: #ffa726;
}

a.active {
   color: #ff8326;
   cursor: initial;
}

a.active:hover {
   text-decoration: none;
}

li {
   line-height: 20px;
   position: relative;
}
li.section {
   font-weight: bold;
   padding: 5px 5px 5px 20px;
}
i, .mat-icon {
   font-size: 18px;
   line-height: 20px;
   text-align: center;
   width: 20px;
   position: absolute;
   left: -20px;
   top: 0;
}
i.fa-briefcase {
   font-size: 16px;
}

i:not(.caret):before {
   vertical-align: middle;
}

i.caret {
   cursor: default;
   font-size: inherit;
   left: 3px;
   top: 7px;
   opacity: 1 !important;
}

i.expanded {
   transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-menu/sign-menu.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;AACrB;AACA;GACG,iBAAiB;GACjB,yBAAyB;AAC5B;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,kBAAkB;GAClB,WAAW;GACX,kBAAkB;GAClB,WAAW;GACX,MAAM;AACT;AACA;GACG,eAAe;AAClB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,kBAAkB;GAClB,SAAS;GACT,QAAQ;GACR,qBAAqB;AACxB;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":["ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.section-break {\n   height: 2em;\n}\n\na:hover {\n   color: #ffa726;\n}\n\na.active {\n   color: #ff8326;\n   cursor: initial;\n}\n\na.active:hover {\n   text-decoration: none;\n}\n\nli {\n   line-height: 20px;\n   position: relative;\n}\nli.section {\n   font-weight: bold;\n   padding: 5px 5px 5px 20px;\n}\ni, .mat-icon {\n   font-size: 18px;\n   line-height: 20px;\n   text-align: center;\n   width: 20px;\n   position: absolute;\n   left: -20px;\n   top: 0;\n}\ni.fa-briefcase {\n   font-size: 16px;\n}\n\ni:not(.caret):before {\n   vertical-align: middle;\n}\n\ni.caret {\n   cursor: default;\n   font-size: inherit;\n   left: 3px;\n   top: 7px;\n   opacity: 1 !important;\n}\n\ni.expanded {\n   transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
